import classnames from "classnames";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import { intl } from "@fidget/common/i18n/TypedIntl";
import styles from "./tileCommon.css";
import { PlanType } from "./upgradeToPlanAgent";

export enum PlanPeriod {
  MONTH = "month",
  YEAR = "year"
}

interface Props {
  handleClick: (plan: PlanType) => void;
  isActive: boolean;
  period: PlanPeriod;
  price: number;
  currency?: string;
}

export const AccelerateTile: React.SFC<Props> = ({
  isActive,
  handleClick,
  period,
  price,
  currency
}) => {
  return (
    <button
      className={classnames(styles.tile, { [styles.active]: isActive })}
      onClick={() => handleClick(PlanType.ACCELERATE)}
    >
      <h3>
        {" "}
        <L10n id={"plan.accelerate"} />{" "}
      </h3>
      <p>
        {" "}
        <L10n id={"plan.accelerate.description"} />{" "}
      </p>
      <p className={styles.price}>{intl.formatPrice(price, currency)}</p>
      <p>
        {" "}
        <L10n id={"plan.accelerate.priceDescription"} values={{ period }} />{" "}
      </p>

      {/* TODO: Annually/monthly toggle, add prop onChangePeriod: () => void */}
      {/*<label className={styles.toggle}>*/}
      {/*<input type="checkbox" checked={period === PlanPeriod.YEAR} onChange={onChangePeriod}/>*/}
      {/*<span className={styles.monthly}><L10n id={"plan.accelerate.monthly"}/></span>*/}
      {/*<span className={styles.slider}></span>*/}
      {/*<span className={styles.annually}><L10n id={"plan.accelerate.annually"}/></span>*/}
      {/*</label>*/}
    </button>
  );
};
